import { OrgAvatar } from '@/components/encuentro/objects/org-avatar'
import { cn } from '@/lib/utils'

// Kept apart from institution-switcher.tsx (its menu pulls the account and
// admin navigation) so Ajustes › Terminología can draw the same corner in its
// short-name preview.

/**
 * The school's own mark: its logo when it has one. Without a logo there is no
 * mark at all and the name stands alone, never an initials square or an
 * invented crest (sistema/Sidebar.md "No"). Two cases count as no logo: an
 * initials placeholder from a generator (ui-avatars, what seed and demo orgs
 * carry) and an image that fails to load. Either way the row is the same one
 * the skeleton draws, so nothing but the mark changes.
 */
export function InstitutionLogo({ url, className }: { url: string | null; className?: string }) {
  return (
    <OrgAvatar
      name=""
      logoUrl={url}
      shape="square"
      fallback="none"
      data-slot="institution-logo"
      className={cn('size-8', className)}
    />
  )
}

/**
 * Names longer than this (one line of the switcher at 16 px, logo included)
 * are long: set a step smaller, with a smaller logo and tighter gaps, so a
 * university's full name ("Universidad Nacional de …", up to about 45
 * characters) reads in two lines instead of ending in "…" (ALU-155). On the
 * phone a long name takes the role line's place, so the bar keeps its 56 px.
 */
export const LONG_INSTITUTION_NAME = 16
